import(/* webpackMode: "eager" */ "C:\\laragon\\www\\agrotechnusa\\src\\app\\syarat-ketentuan\\page.tsx");
